import React from 'react';
import './Contact.css'
const Contact = () => {
    return (
        <div class="form-box">
            <form action="https://formspree.io/f/xdoyagvj" method="POST" class="needs-validation shadow p-5" novalidate>
            <h1 className="h1-tag">Get In Touch</h1>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input class="form-control" id="name" type="text" placeholder="Your your name" name="name" required/>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input class="form-control" id="email" type="email" placeholder="Enter your Email" name="email" required/>
                </div>
                <div class="form-group">
                    <label for="message">Message</label>
                    <textarea class="form-control" id="message" placeholder="Your message here" rows="5" name="message" required></textarea>
                </div>
                <button type="submit" class="btn btn-primary mt-2">Send</button>
            </form>
        </div >
        
    );
};

export default Contact;